module.exports = __webpack_public_path__ + "static/media/menu_icon.09d800ae.svg";